import NidApp from "./api.js";

function initializeFlexslider($element) {

	var prodSliderArgs = NidApp.getProductSliderArgs($element);

	if ($element.hasClass('flexslider') && !$element.hasClass('slider-active')) {
		if ($element.hasClass('prod-flexslider')) {
			$element
				.flexslider(prodSliderArgs)
				.addClass('slider-active');
		}
		if ($element.hasClass('how-to-flexslider')) {
			$element
				.flexslider({animation: 'slide'})
				.addClass('slider-active');
		}
	}
}


/**
 * If a passed slide is in mobile mode, change background image
 * and fix aspect ratio
 *
 * @param {jQuery} $slide
 */
function maybeAlterFrontPageSlide( $slide ) {
	var pageWidth = window.outerWidth;
	var backgroundImage = $slide.data( 'desktop' );
	if ( pageWidth < 660 ) {
		var slideHeight = pageWidth * ( 3/4 );
		backgroundImage = $slide.data( 'mobile' ) || $slide.data( 'desktop' );
		$slide.height( slideHeight ).css('min-height', 200).css( 'background-image', backgroundImage );
	} else {
		$slide.height( 'auto' ).css( 'background-image', backgroundImage ).css('min-height', 350);
	}
}


;(function ($, nordsjo, NidApp) {

	/**
	 * Render an popup video.
	 *
	 * @param {string} header Modal header.
	 * @param {string} oEmbed oEmbed code.
	 */
	function renderPushVideo(header, oEmbed) {
		var $template = $('#fp-modal-video-template').html(),
			data = {
				header: header,
				video: oEmbed
			},
			html = _.template($template)(data);

		openModal(html);
	}


	/**
	 * If a passed slide is in mobile mode, change background image
	 * and fix aspect ratio
	 *
	 * @param {jQuery} $slide
	 */
	function maybeAlterFrontPageSlide( $slide ) {
		var pageWidth = $(window).width();
		var backgroundImage = $slide.data( 'desktop' );

		if ( pageWidth < 660 ) {
			var slideHeight = pageWidth * ( 3/4 );
			backgroundImage = $slide.data( 'mobile' ) || $slide.data( 'desktop' );
			$slide.height( slideHeight ).css('min-height', 200).css( 'background-image', 'url(' + backgroundImage + ')' );
			$slide.find('img').attr('src',backgroundImage);
		} else {
			$slide.height( 'auto' ).css( 'background-image', 'url(' + backgroundImage + ')' ).css('min-height', 350);
			$slide.find('img').attr('src',backgroundImage);
		}
	}


	$(function () {

		$('#view-store-trigger').on('click', function (e) {
			e.preventDefault();

			$('body, html').animate({scrollTop: window.pageYOffset - 20}, 100);
			$('#show-store-trigger').trigger('click');
		});

		$('.flexslider-product-push').flexslider({
			animation: "slide",
			controlNav: false,
			pauseOnHover: true

		});

		// Make whole pushes of certain types clickable
		$('.pushes-wrapper-container').on('click', function (e) {
			var $this = $(e.target);
			if ($this.hasClass('push-video')) {
				return;
			}

			var $parent = $this.parents('.push-grid');
			if ($parent.hasClass('frontpage_image_text_layout_two_push') || $parent.hasClass('frontpage_image_text_layout_one_push') || $parent.hasClass('frontpage_stores_push') )
			{
				window.location.href = $('a.button', $parent).attr('href');
			}
		});

		// Tabs;
		$('.tabs').on('click', 'a', function (e) {
			e.preventDefault();

			var $this = $(this),
				slideIndex,
				sectionId,
				$parent,
				$section,
				$currentSection;

			if ($this.hasClass('active')) {
				return false;
			}

			slideIndex = $this.data('slide-index');
			$parent = $this.closest('ul');
			sectionId = $parent.data('section-id');
			$section = $(document.getElementById('frontpage-section-' + sectionId));
			$currentSection = $('.frontpage-section', $section).eq(slideIndex);

			$('a', $parent).removeClass('active');
			$this.addClass('active');

			$('.frontpage-section', $section).hide();
			$currentSection.fadeIn();

			initializeFlexslider($currentSection);

			$.event.trigger({
				type: 'tabChanged',
				index: slideIndex
			});
		});

		// Videos
		$('.push-video').on('click', function (e) {
			e.preventDefault();
			$('body').addClass('video-modal-open');

			var width = Math.floor(window.innerWidth);
			if (width > 660) {
				width = width * 0.8;
			} else {
				width = width - 20;
			}
			var height = Math.floor(width * 0.75);
			var $modal = $('#fp-video-modal').clone();
			$('.modal-dialog', $modal).css('width', width);
			$('.modal-content', $modal).css('opacity', 0);
			$modal.modal();

			$.ajax({
				type: 'POST',
				url: nordsjo.ajaxurl,
				data: {
					action: 'nid_get_oembed_code',
					video_url: e.target.href,
					width: width,
					height: height
				}
			}).done(function (result) {
				$('#fp-modal-body', $modal).html(result);
				$modal.on('click', '.close', function (e) {
					$('body').removeClass('video-modal-open');
					$('#fp-modal-body', $modal).html('');
				});

				$('.modal-content', $modal).css('opacity', 100);
			});
		});


		if (typeof $.fn.flexslider !== 'undefined' || !$('body').hasClass('single-frontpage')) {

			// Banner slider
			var $slider = $( '.main-flexslider' );

			// Only slide if there are enough sliders
			if ( $( '.slides .banner', $slider ).length > 1 ) {
				$slider.flexslider({
					controlNav: false,
					animation : 'fade',
					prevText  : '',
					nextText  : '',
				});
			}

			if( $('body').hasClass( 'home' ) ) {
				var $carousel = $('.carousel');
				var resizeTimer;

				if ($carousel.length < 1) {
					return;
				}

				var $banner = $( '.banner', $carousel );
				maybeAlterFrontPageSlide( $banner );

				$(window).on('resize', function(e) {

					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(function() {
						maybeAlterFrontPageSlide( $banner );
					}, 250);
				});
			}


			// How to carousel
			$('.first.how-to-flexslider').flexslider({
				animation: 'slide'
			});


			// Product crousel
			var $el = $('.first.prod-flexslider');
			initializeFlexslider($el);
		}

		if( $('body').hasClass( 'home' ) ) {
			var $carousel = $('.carousel');
			var resizeTimer;

			if ($carousel.length < 1) {
				return;
			}

			var $banners = $( '.banner', $carousel );
			_.each( $banners, function ( banner ) {
				maybeAlterFrontPageSlide( $(banner) );
			} );

			$(window).on('resize', function(e) {

				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {

					_.each( $banners, function ( banner ) {
						maybeAlterFrontPageSlide( $(banner) );
					} );

				}, 250);

			});

		}

	});

}(jQuery, nordsjo, NidApp));
